module.exports = __webpack_public_path__ + "img/socio7.1a83ab65.png";